// extracted by mini-css-extract-plugin
export default {"companyColabText":"OurClients_companyColabText__039NU","brandContainer":"OurClients_brandContainer__Jfdrv","brandImageContainer":"OurClients_brandImageContainer__6dtMI"};